import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100vh',
    background: '#F2F1F1',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    overflowX: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  rootForm: {
    display: 'flex',
    flexDirection: 'column',
    width: '90%',
    marginTop: '31vh',
    marginBottom: '3%',
    maxHeight: '57vh !important',
    overflowX: 'hidden',
  },
  rootClock: {
    display: 'flex',
    flexDirection: 'row',
    width: '90%',
    marginTop: '22vh',

    paddingTop: '4%',
    paddingBottom: '4%',
    paddingLeft: '3%',
    paddingRight: '3%',
  },

  divLeft: {
    display: 'flex',
    flexDirection: 'column',
    width: '37%',
    marginTop: '12%',
    marginLeft: '2%',
  },
  itemName: {
    width: '137px',
  },
  title: {
    fontSize: '22px',
    color: '#696969',
    fontWeight: 600,
  },

  subItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: '#F4F4F4',
    color: '#696969',
    fontSize: '16px',
    fontWeight: 600,
    paddingTop: '4%',
    paddingBottom: '4%',
    paddingLeft: '3%',
    paddingRight: '3%',
    borderRadius: '5px',
    marginTop: '10%',
  },
  divRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '70%',
    marginTop: '4%',
    marginLeft: '2%',
  },
  icon: {
    fontSize: '110px',
    color: '#696969',
    fontWeight: 600,
  },
  time: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: '#F4F4F4',
    color: '#696969',
    fontSize: '88px',
    fontWeight: 700,
    paddingTop: '1%',
    paddingBottom: '1%',
    paddingLeft: '20%',
    paddingRight: '20%',
    borderRadius: '5px',
    marginTop: '3%',
  },
  box: {
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    fontSize: '16px',
    borderWidth: '1px',
    border: '1px solid',
    borderColor: '#263a9e',
    padding: '15px',
  },
  box_pontos: {
    // display: 'flex',
    // flexDirection: 'row',
    borderWidth: '1px',
    border: '1px solid',
    borderColor: '#263a9e',
    padding: '15px',
  },
  tableHeadCells: {
    fontWeight: 'bold',
  },
  tableCells: {
    fontWeight: 'bold',
    textAlign: 'center',
    padding: '6px 0px 6px 16px',
  },
  boxCells: {
    border: '1px solid',
    borderColor: '#263a9e',
    minHeight: '50px',
  },

  table: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    marginTop: '31vh',
    overflowX: 'hidden',
    height: '57vh !important',
  },
  inputEmail: {
    textTransform: 'lowercase',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 600,
  },
  registerBtn: {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-end',
    margin: '16px 0 24px',
    alignItems: 'flex-start',
  },
  button: {
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    textDecoration: 'none',
    cursor: 'pointer',
    width: '110px',
    backgroundColor: '#026894',
    color: '#fff',
    height: '32px',
    boxShadow: 'none',
    border: 'none',
    borderRadius: '4px',
    textTransform: 'capitalize',
    fontSize: '14px',
    marginRight: '16px',
    '&:hover': {
      backgroundColor: '#064561',
    },
  },
  buttonVisualize: {
    marginRight: '16px',
  },
  accordionRoot: {
    boxShadow: 'none',
    borderBottom: 'none',
  },
  inputSalario: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '44px',
    paddingTop: '7px',
    paddingBottom: '7px',
    paddingLeft: '1%',
    paddingRight: '5px',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
  },
  inputText: {
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  large: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#FFF',
    marginBottom: '2%',
    color: '#949494',
  },
  input2: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '38px',
    textTransform: 'uppercase',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '10px',
    fontSize: '16px',
    opacity: '100%',
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '99%',
    backgroundColor: '#FFF',
    marginBottom: '2%',
    borderRadius: '4px',
  },
  medium: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '97%',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  small: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    width: '93%',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  small_date: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#FFF',
    marginBottom: '16px',
    color: '#949494',
  },
  input: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '44px',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '1%',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
  },
  inputTime: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '44px',
    paddingTop: '4px',
    paddingBottom: '4px',
    fontSize: '16px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
    textAlign: 'center',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'right',
    alignItems: 'flex-end',
  },
  itemSmall: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    justifyContent: 'right',
    alignItems: 'flex-start',
  },
  summary: {
    backgroundColor: '#C4C4C4',
    borderRadius: '5px',
  },
  details: {
    backgroundColor: '#ECECEC',
    alignItems: 'center',
  },
  grid: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  grid2: {
    display: 'block',
  },
  divButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: '3%',
    marginBottom: '3%',
  },
  selectBox: {
    float: 'left',
    width: '97%',
    color: '#6161ff',
    backgroundColor: '#fff',
    textDecoration: 'underline',
    height: '43px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '15px',
    borderRadius: '5px',
    cursor: 'pointer',
    borderWidth: 0,
  },
  label: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '13px',
    fontWeight: 'bold',
    float: 'left',
    marginBottom: '7px',
    width: '97%',
    textAlign: 'center',
  },
  porcentage: {
    marginRight: '5px',
    borderBottom: '1px solid',
    flex: 1,
    height: '45px',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
  },
  divLogo: {
    background: '#fff',
    padding: '12px',
    width: '92%',
    marginBottom: '14px',
  },
  cnpjBox: {
    display: 'grid',
    gridTemplateColumns: '96px 1fr',
    width: '98%',
  },
  inputActualHour: {
    flex: 1,
    color: '#949494',
    borderWidth: 0,
    height: '30px',
    paddingTop: '10px',
    paddingBottom: '10px',
    fontSize: '23px',
    opacity: '100%',
    textTransform: 'uppercase',
    outline: 'none',
    borderRadius: '5px',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  buttonRegister: {
    height: '80px',
    width: '100%',
    backgroundColor: '#026894',
    color: '#FFF',
    boxShadow: 'none',
    border: 'none',
    textTransform: 'capitalize',
    fontSize: '16px',
    '&:hover': {
      backgroundColor: '#034561',
    },
  },
}));

export default useStyles;
